var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.144,
    height: 43.833,
    viewBox: "0 0 52.144 43.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.502,
    cy: 0.929,
    r: 0.457,
    gradientTransform: "translate(0.687 -0.824) scale(0.841 1.887)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff772c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -16.269,
    y1: 0.499,
    x2: -15.269,
    y2: 0.499,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ef5b3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#c54b31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#813120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#240e09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.291,
    cy: 0.685,
    r: 0.504,
    gradientTransform: "matrix(-0.06, -0.998, 0.998, -0.06, 53.648, -223.79)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#009148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#005e2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00351a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#00180c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -76.649,
    cy: -133.382,
    r: 0.5,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -82.397,
    cy: -140.28,
    r: 0.5,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: -26.068,
    cy: -48.388,
    r: 0.5,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: -65.495,
    cy: -106.49,
    r: 0.497,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: -127.142,
    cy: -227.963,
    r: 0.5,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: -131.337,
    cy: -202.746,
    r: 0.5,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: -176.099,
    cy: -291.498,
    r: 0.503,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: -87.968,
    cy: -135.385,
    r: 0.5,
    gradientTransform: "translate(0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ef8e3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#c57531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#814d20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#241609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "icon-back",
    transform: "translate(-0.016 0)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "space"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M1,39.24c1.82,7.09,45.55,5.57,49.3-1.8C53.65,30.73,52,8.63,49.1,3.85,45.1-2.67,6.29,0,3.1,5.14.09,9.92-.93,31.88,1,39.24Z",
    fill: "url(#radial-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M1.1,38c1.81,6.85,45.28,3.82,49-3.29C53.5,28.24,51.9,8.77,49,4.16,45.06-2.15,6.36.36,3.16,5.31.18,9.92-.78,30.89,1.1,38Z",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M1.64,37.38c1.77,6.64,44.3,3.6,48-3.3C52.91,27.8,51.35,9,48.51,4.48,44.64-1.62,6.79.76,3.66,5.57.74,10-.19,30.5,1.64,37.38Z",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M48.72,34.2A71,71,0,0,1,3.89,38.49S20,37.63,27.22,35C39.55,30.47,45.48,29.14,48.72,34.2Z",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M15.37,11.34a1.272,1.272,0,1,1-1.195,1.345A1.272,1.272,0,0,1,15.37,11.34Z",
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M15.52,12.25a.354.354,0,1,1-.33.37.35.35,0,0,1,.33-.37Z",
    fill: "#ffffab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M17.1,5.86a1.27,1.27,0,1,1-.875.428A1.28,1.28,0,0,1,17.1,5.86Z",
    fill: "url(#radial-gradient-3)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M17.26,6.77a.36.36,0,1,1-.3.355A.36.36,0,0,1,17.26,6.77Z",
    fill: "#ffffab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M16.08,21.57a1.28,1.28,0,1,1-1.118,1.345A1.28,1.28,0,0,1,16.08,21.57Z",
    fill: "url(#radial-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M16.23,22.48a.36.36,0,0,1,.38.34.35.35,0,0,1-.33.37.36.36,0,1,1-.05-.71Z",
    fill: "#ffffab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M10.08,3.06A3.55,3.55,0,1,1,7.619,4.247,3.57,3.57,0,0,1,10.08,3.06Z",
    fill: "url(#radial-gradient-5)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M10.51,5.62a1,1,0,1,1-.93,1A1,1,0,0,1,10.51,5.62Z",
    fill: "#ffffab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M20.26,30.3a1.7,1.7,0,1,1-1.177.571A1.71,1.71,0,0,1,20.26,30.3Z",
    fill: "url(#radial-gradient-6)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M20.47,31.53A.46.46,0,0,1,21,32a.47.47,0,0,1-.44.5A.48.48,0,0,1,20,32a.47.47,0,0,1,.47-.47Z",
    fill: "#ffffab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M5.39,38.32a.85.85,0,1,1-.8.9.84.84,0,0,1,.8-.9Z",
    fill: "url(#radial-gradient-7)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M5.5,38.93a.22.22,0,0,1,.24.22.236.236,0,1,1-.24-.22Z",
    fill: "#ffffab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M29.07,20.17a.85.85,0,1,1-.8.9.86.86,0,0,1,.8-.9Z",
    fill: "url(#radial-gradient-8)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M29.18,20.78A.24.24,0,1,1,29,21a.25.25,0,0,1,.18-.22Z",
    fill: "#ffffab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M17.25,33.55a.64.64,0,0,1,.67.6.63.63,0,0,1-.59.67.65.65,0,0,1-.68-.6A.64.64,0,0,1,17.25,33.55Z",
    fill: "url(#radial-gradient-9)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M17.33,34a.18.18,0,1,1-.18.18.18.18,0,0,1,.18-.18Z",
    fill: "#ffffab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M27.12,33a1.33,1.33,0,1,1-1.245,1.408A1.32,1.32,0,0,1,27.12,33Z",
    fill: "url(#radial-gradient-10)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M27.28,34a.37.37,0,1,1-.34.39.37.37,0,0,1,.34-.39Z",
    fill: "#ffffab"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M47.55,35.48c-.22-.76,1.79-4.23,2.3-4.21s0,2.28-.26,2.81S47.67,35.86,47.55,35.48Z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M30.36,7.72S24.48,10,16.14,19.9A37.45,37.45,0,0,0,30.36,31.55l1.87-3A46.06,46.06,0,0,1,23,19.64a22.73,22.73,0,0,1,8.48-8.86Z",
    fill: "#28185d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M3.55,5.6s29.58-9.45,45.06-1c0,0,1.63,1.3,2.25,6.34,0,0-1.24-4.44-10.51-3.8C32.38,7.67,20,21.05,7.1,16.74.61,14.57,3.55,5.6,3.55,5.6Z",
    fill: "url(#linear-gradient-4)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M3.55,9.48S2.13,5.86,4.86,4.56,16.53,2,17,2.37,13.19,4.22,11,5,4.66,10.1,3.55,9.48Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.e6ebe17e603fa976afa91be1043560e5.svg";
export { ForwardRef as ReactComponent };